<template>
  <b-container fluid>
    <div class="row mt-4 mb-4 no-gutters">
            <div class="col-2">
                    <b-dropdown variant="link" no-caret v-if="admin == 'true'">
                            <template slot="button-content"><icon name="bars" scale="1.5" class="btn-menu"></icon></template>
                            <b-dropdown-item :to="{ name: 'stores' }">Lojas</b-dropdown-item>
                            <b-dropdown-item :to="{ name: 'users' }">Usuários</b-dropdown-item>
                            <b-dropdown-item :to="{ name: 'checks' }">Checks</b-dropdown-item>
                    </b-dropdown>
            </div>
            <div class="col-8 text-center"><b-img src="http://api.checkpoint.recco.com.br/image_recco/recco.png" fluid style="width:100%; max-width:200px;"/></div>
            <div class="col-2 text-right"><button @click="logout()" class="btn-logoff"><icon name="sign-out" scale="2"></icon></button></div>
    </div>
    <div class="row" v-if="level == 'supervisor'">
        <div class="col-12">
            <select class="custom-select" v-model="store" @change="setStore()">
                    <option value="all">Todas as Lojas</option>
                    <option v-for="(store, index) in stores" v-bind:key="'store-'+index" v-bind:value="store.id_store">{{ store.nm_store }}</option>
            </select>
        </div>
    </div>
   <b-card-group deck>
    <!-- Ranking -->
    <div v-if="level == 'supervisor'" class="ranking card text-white bg-info mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'ranking' }">
            <div class="card-body">
                <h4 class="card-title"><span v-show="spinner.ranking"><icon name="cog" scale="2.5" spin></icon></span> Ranking</h4>
                <div class="row pt-1 pb-1" v-for="(ranking, index) in ranking.stores" v-bind:key="'r-'+index" v-if="index < 10">
                        <b-col cols="6" class="text-truncate">{{ ranking.ranking }}º {{ ranking.nm_store }}</b-col>
                        <b-col cols="6"><b-progress show-value height="26px" variant="warning" :value="ranking.sc_store"></b-progress></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <div v-if="level == 'store'" class="ranking card text-white bg-info mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'score', params: { store: ranking.id_store }}">
            <div class="card-body">
                <h4 class="card-title"><span v-show="spinner.ranking"><icon name="cog" scale="2.5" spin></icon></span> {{ ranking.nm_store }}</h4>
                <div class="row score" v-show="!spinner.ranking">
                        <b-col cols="5"><span>{{ ranking.ranking }}º</span></b-col>
                        <b-col cols="7"><p><strong>{{ ranking.score }}</strong> Score</p></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <!-- Atrasados -->
    <div v-if="level == 'supervisor'" class="checks card text-white bg-danger mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'atrasados' }">
            <div class="card-body">
                <h4 class="card-title"><span><icon name="cog" scale="2.5" spin v-show="spinner.atrasados"></icon>{{ atrasados.size }}</span> Atrasados</h4>
                <div class="row pb-2" v-for="(atrasado, index) in atrasados.checks" v-bind:key="'at-'+index">
                        <b-col cols="2" class="p-1"><strong>{{ atrasado.days }}</strong> <span v-if="atrasado.days == 1">dia</span><span v-if="atrasado.days > 1">dias</span></b-col>
                        <b-col cols="8" class="p-1"><span>{{ atrasado.nm_check }}</span> <h4>{{ atrasado.nm_store }}</h4></b-col>
                        <b-col cols="2" class="p-1"><b-link class="text-white" :to="{ name: 'check', params: { type: 'atrasado', store: atrasado.id_store, check: atrasado.id_check }}"><icon name="edit" scale="2"></icon></b-link></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <div v-if="level == 'store'" class="checks card text-white bg-danger mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'atrasados' }">
            <div class="card-body">
                <h4 class="card-title"><span><icon name="cog" scale="2.5" spin v-show="spinner.atrasados"></icon>{{ atrasados.size }}</span> Atrasados</h4>
                <div class="row pb-2" v-for="(atrasado, index) in atrasados.checks" v-bind:key="'at-'+index">
                        <b-col cols="2" class="p-1"><strong>{{ atrasado.days }}</strong> <span v-if="atrasado.days == 1">dia</span><span v-if="atrasado.days > 1">dias</span></b-col>
                        <b-col cols="8" class="p-1"><span>{{ atrasado.nm_check }}</span> <h4>{{ atrasado.nm_store }}</h4></b-col>
                        <b-col cols="2" class="p-1"><b-link class="text-white" :to="{ name: 'history', params: { store: atrasado.id_store, check: atrasado.id_check }}"><icon name="info-circle" scale="2"></icon></b-link></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <!-- Abertos -->
    <div class="checks card text-white bg-warning mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'abertos' }">
            <div class="card-body">
                <h4 class="card-title">
                    <span>
                        <icon name="cog" scale="2.5" spin v-show="spinner.abertos"></icon>
                        {{ abertos.size }}
                    </span>
                    Trabalhando</h4>
                <div class="row pb-2" v-for="(aberto, index) in abertos.checks" v-bind:key="'ab-'+index">
                        <b-col cols="2" class="p-1"><strong>{{ aberto.days }}</strong> <span v-if="aberto.days == 1">dia</span><span v-if="aberto.days > 1">dias</span></b-col>
                        <b-col cols="8" class="p-1">
                            <span>{{ aberto.nm_check }}</span>
                            <icon id="newPost" name="circle" scale="0.7" v-if="aberto.new_post > 0"></icon>
                            <h4>{{ aberto.nm_store }}</h4>
                        </b-col>
                        <b-col cols="2" class="p-1"><b-link class="text-white" :to="{ name: 'check', params: { type: 'aberto', store: aberto.id_store, check: aberto.id_check }}"><icon name="edit" scale="2"></icon></b-link></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <!-- Próximos -->
    <div v-if="level == 'supervisor'" class="checks card text-white bg-success mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'proximos' }">
            <div class="card-body">
                <h4 class="card-title"><span v-show="spinner.proximos"><icon name="cog" scale="2.5" spin></icon></span> Próximos</h4>
                <div class="row pb-2" v-for="(proximo, index) in proximos.checks" v-bind:key="'pr-'+index">
                        <b-col cols="2" class="p-1"><strong>{{ proximo.days }}</strong> <span v-if="proximo.days == 1">dia</span><span v-if="proximo.days > 1">dias</span></b-col>
                        <b-col cols="8" class="p-1">
                          <span>
                            {{ proximo.nm_check }}
                            <span v-if="proximo.dt_holiday_dif > 0" class="holiday">(Férias)</span>
                          </span>
                          <h4>
                            {{ proximo.nm_store }}
                          </h4>
                        </b-col>
                        <b-col cols="2" class="p-1"><b-link class="text-white" :to="{ name: 'check', params: { type: 'proximo', store: proximo.id_store, check: proximo.id_check }}"><icon name="edit" scale="2"></icon></b-link></b-col>
                </div>
            </div>
        </b-link>
    </div>

    <div v-if="level == 'store'" class="checks card text-white bg-success mt-2" style="min-width:20rem;">
        <b-link class="text-white" :to="{ name: 'proximos' }">
            <div class="card-body">
                <h4 class="card-title"><span v-show="spinner.proximos"><icon name="cog" scale="2.5" spin></icon></span> Próximos</h4>
                <div class="row pb-2" v-for="(proximo, index) in proximos.checks" v-bind:key="'pr-'+index">
                        <b-col cols="2" class="p-1"><strong>{{ proximo.days }}</strong> <span v-if="proximo.days == 1">dia</span><span v-if="proximo.days > 1">dias</span></b-col>
                        <b-col cols="8" class="p-1">
                          <span>
                            {{ proximo.nm_check }}
                          </span>
                          <h4>
                            {{ proximo.nm_store }}
                          </h4>
                        </b-col>
                        <b-col cols="2" class="p-1"><b-link class="text-white" :to="{ name: 'history', params: { store: proximo.id_store, check: proximo.id_check }}"><icon name="info-circle" scale="2"></icon></b-link></b-col>
                </div>
            </div>
        </b-link>
    </div>
    </b-card-group>
  </b-container>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
	components: { Icon },
  data () {
    return {
        level: localStorage.getItem('level'),
        admin: localStorage.getItem('admin'),
        spinner: {
            ranking: true,
            atrasados: true,
            abertos: true,
            proximos: true
        },
        store: 'all',
        stores: [],
        ranking: [],
        atrasados: [],
        abertos: [],
        proximos: [],
    }
	},
	mounted () {
            http.get('/store/own').then(response => { this.stores = response.data; })
            http.get('/ranking/geral').then(response => { this.spinner.ranking = false; this.ranking = response.data; })
            // Verifica se existe a loja global selecionada.
            if (localStorage.getItem('global-store')) {
                this.store = localStorage.getItem('global-store')
                http.get('/checks/atrasados/'+this.store+'/4').then(response => { this.spinner.atrasados = false; this.atrasados = response.data; })
                http.get('/checks/abertos/'+this.admin+'/'+this.store+'/4').then(response => { this.spinner.abertos = false; this.abertos = response.data; })
                http.get('/checks/proximos/'+this.store+'/date/4').then(response => { this.spinner.proximos = false; this.proximos = response.data; })
            }
            else {
                http.get('/checks/atrasados/all/4').then(response => { this.spinner.atrasados = false; this.atrasados = response.data; })
                http.get('/checks/abertos/'+this.admin+'/all/4').then(response => { this.spinner.abertos = false; this.abertos = response.data; })
                http.get('/checks/proximos/all/date/4').then(response => { this.spinner.proximos = false; this.proximos = response.data; })
            }
	},
	methods: {
            setStore () {
                localStorage.setItem('global-store', this.store)
                location.reload()
            },
            logout () {
                swal({
                    title: 'Sair do sistema?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DC3545',
                    cancelButtonColor: '#DCDCDC',
                    confirmButtonText: 'Sair',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.value) {
                        // Limpando o localstorage.
                        localStorage.clear();
                        // Redireciona para login.
                        this.$router.push('login')
                    }
                })
            }
    }
}
</script>

<style>
.btn-menu { padding:0; margin:0; color:#AFAFAF; }
.btn-logoff { background:none; border:none; color:#AFAFAF; }

.ranking .row div { line-height:26px; }

h4.card-title { line-height:40px; font-size:1.2em; }
h4.card-title span { display:block; float:left; margin-right:10px; width:40px; height:40px; border-radius:20px; font-size:20px; background:#FFF; text-align:center; }
.bg-info    h4.card-title span { color:#17A2B8; }
.bg-info    h4.card-title span svg { color:#17A2B8; }
.bg-danger  h4.card-title span { color:#DC3545; }
.bg-danger  h4.card-title span svg { color:#DC3545; }
.bg-warning h4.card-title span { color:#FFC107; }
.bg-warning h4.card-title span svg { color:#FFC107; }
.bg-success h4.card-title span { color:#28A745; }
.bg-success h4.card-title span svg { color:#28A745; }

.checks .row div:first-child { text-align:center; }
.checks .row div:first-child strong { display:block; font-size:19px; }
.checks .row div:last-child { text-align:center; }

.score { text-align:center; }
.score span { display:block; height:100px; background:url('http://api.checkpoint.recco.com.br/image_recco/trophy.png') no-repeat center; background-size:100%; font-size:30px; padding-top:14px; opacity:0.3; }
.score p { text-transform:uppercase; }
.score p strong { display:block; font-size:72px; line-height:70px; }
#newPost{
    color: #DC3545;
    text-align:center;
    margin-left: 3px;
    margin-bottom: 1px;
}
.holiday{ font-size: 8px; }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue